// extracted by mini-css-extract-plugin
export default {"usersList":"styles_usersList__4pBCK","chatsTitle":"styles_chatsTitle__OBass"};